import React from "react"
import { useKeenSlider } from "keen-slider/react"
import(/* webpackPrefetch: true */ "keen-slider/keen-slider.min.css")
import Lightbox from "react-images"
import useIsMobile from "../Hooks/useIsMobile"
import ImageSliderOverlay from "./ImageSliderOverlay"

const ProductImageSlideshow = props => {
    const { images } = props
    const [activeImageIndex, setActiveImageIndex] = React.useState(0)
    const [isImageOverlayOpen, setIsImageOverlayOpen] = React.useState(false)
    const [loadedImages, setLoadedImages] = React.useState([true, true]) // image 1 and 2 always loaded

    const [sliderRef, slider] = useKeenSlider({
        loop: true,
        slideChanged: (s) => setActiveImageIndex(s.details().relativeSlide),
    })
    
    const openCurrentImage = () => {
        if(activeImageIndex == null)
            return
        setIsImageOverlayOpen(true)
    }

    // Lazy load, load current + next image
    React.useEffect(() => {
        const loaded = [...loadedImages]
        if(!loaded[activeImageIndex]) {
            loaded[activeImageIndex] = true
        }

        if(images.length-1 >= activeImageIndex+1 && !loaded[activeImageIndex+1])
            loaded[activeImageIndex+1] = true

        setLoadedImages(loaded)
    }, [activeImageIndex])

    return <>
        <div className="product-images keen-slider" ref={sliderRef}>
            {images.map((image, i) => <div className="keen-slider__slide" key={i+image.src}>
                <img src={loadedImages[i] ? image.src : ""} alt={image.alt} width={image.width == 0 ? null : image.width} height={image.height == 0 ? null : image.height} onClick={openCurrentImage} />
              </div>
            )}
        </div>
        {slider && images.length > 1 && 
            <>
                <button className="product-images__arrow product-images__arrow--left" onClick={() => slider.prev()}>
                    <i className="icon icon-chevron-left"></i>
                </button>
                <button className="product-images__arrow product-images__arrow--right" onClick={() => slider.next()}>
                    <i className="icon icon-chevron-right"></i>
                </button>
            </>
        }
        <div className="product-images__bullets">
            {images.length > 1 && images.map((_, i) =>
                <div key={"bullet"+i}
                    onClick={() => { slider.moveToSlideRelative(i) }}
                    className={["product-images__bullet", i == activeImageIndex ? "product-images__bullet--active" : ""].join(" ")}>
                        <svg width="16" height="90" viewBox="0 0 16 90" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.51613 90H14.8387L15.9355 89.4371V87.8735H14.8387V86.3725L16 84.934V38.6518L13.9355 34.1487V24.0792H13.1613C13.1613 24.0792 13.1613 14.1974 10.2581 4.69076C9.29032 1.56359 8.64516 0 8.06452 0H8C7.35484 0 6.70968 1.62613 5.80645 4.69076C2.90323 14.1974 2.90323 24.0792 2.90323 24.0792H2.06452V34.1487L0 38.6518V84.934L1.16129 86.3725V87.8735H0.0645161V89.4371L1.16129 90H7.48387H8.51613Z"/>
                        </svg>
                </div>
            )}
        </div>
        <ImageSliderOverlay 
            images={images.map(img => img.original)}
            onClose={() => setIsImageOverlayOpen(false)}
            initialIndex={activeImageIndex}
            isOpen={isImageOverlayOpen}
        />
    </>
}

export default ProductImageSlideshow